import React, { useState, useEffect } from "react";
import "./index.css";
import img1 from "../../Components/images/IMG_0747.JPG";
import img2 from "../../Components/images/IMG_0746.JPG";
import image2 from "../../Components/images/power-grd.jpg";
import image1 from "../../Components/images/About-Us.png";
import image3 from "../../Components/images/grid-system.jpg";
import karuna from "../../Components/images/Karuna.jpg";

const headerImages = [image2, image1, image3];

const people = [
  {
    name: "Sharada Shrestha",
    role: "Managing Director",
    imageUrl: img1,
  },
  {
    name: "Bharat Raj Poudel",
    role: "Team Leader",
    imageUrl: img2,
  },
  {
    name: "Karuna Sharma",
    role: "Climate and Sustainability Expert",
    imageUrl: karuna,
  },
];

const AboutUs = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto slide every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % headerImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-white text-gray-800">
      {/* Header slideshow with overlay title */}
      <div className="relative w-full h-64 sm:h-80 md:h-96 overflow-hidden">
        {headerImages.map((img, idx) => (
          <img
            key={idx}
            src={img}
            alt={`Slide ${idx + 1}`}
            className={`absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-1000 ${
              idx === currentIndex ? "opacity-100 z-10" : "opacity-0 z-0"
            }`}
          />
        ))}

        {/* Navigation dots */}
        <div className="absolute bottom-5 left-1/2 transform -translate-x-1/2 flex space-x-3 z-10">
          {headerImages.map((_, idx) => (
            <button
              key={idx}
              className={`w-3 h-3 rounded-full transition-colors ${
                idx === currentIndex ? "bg-indigo-500" : "bg-gray-400"
              }`}
              onClick={() => setCurrentIndex(idx)}
              aria-label={`Go to slide ${idx + 1}`}
            />
          ))}
        </div>
      </div>

      {/* Rest of your page sections */}
      {/* Intro Section */}
      <section className="bg-gray-100 px-6 py-16 md:px-12 lg:px-24">
        <div className="max-w-6xl mx-auto grid gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold mb-4 border-l-4 border-indigo-500 pl-4">
              About SETM
            </h2>
            <p className="text-gray-700 leading-relaxed text-md">
              Sustainable Energy and Technology Management (SETM) is a
              professional energy management company dedicated to advancing
              clean energy pathways and supporting the global transition to
              net-zero emissions.
            </p>
            <br />
            <p className="text-gray-700 leading-relaxed text-md">
              With trusted partnerships and world-class expertise, we work with
              families, local governments, city councils, commercial buildings,
              regional communities, and utilities to plan, design, and implement
              innovative energy solutions that drive clean energy access,
              economic development, and carbon reduction.
            </p>
            <br />
            <p className="text-gray-700 leading-relaxed text-md">
              We specialize in the full spectrum of clean energy services,
              including feasibility studies, the design and installation of
              mini-grids such as micro-hydro and solar PV systems, battery
              storage solutions, engineering design and protection of
              grid-connected technologies, and tender preparation and
              evaluation. Our expertise extends to demand-side energy
              management, sustainability assessments, microgrid development, and
              end-to-end project management—ensuring seamless delivery from
              concept to execution.
            </p>
            <br />
            <p className="text-gray-700 leading-relaxed text-md">
              As one of Nepal’s leading renewable energy firms, SETM brings
              together a seasoned team of engineers, sustainability experts,
              analysts, and management professionals who are passionate about
              delivering impactful results.
            </p>
            <br />
            <p className="text-gray-700 leading-relaxed text-md">
              We are committed to delivering exceptional, efficient, and
              forward-thinking outcomes—combining innovation, technical
              excellence, and a deep understanding of our clients' needs. SETM
              offers end-to-end management consulting services across the
              renewable energy value chain, bridging the gap between strategy
              and implementation with integrated solutions that merge technology
              and management expertise.
            </p>
            <br />
            <p className="text-gray-700 leading-relaxed text-md"></p>
          </div>
        </div>
      </section>

      {/* Mission, Vision, Values */}
      <section className="px-6 py-20 md:px-12 lg:px-24 bg-white border-t border-gray-200">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-10 text-center md:text-left">
            <div>
              <h3 className="text-xl font-semibold text-indigo-600 mb-3">
                Our Mission
              </h3>
              <p className="text-gray-700">
                We facilitate the transition to cleaner energy markets by
                providing innovative, cost-effective, and high-quality services
                that increase access to clean energy for our clients.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-indigo-600 mb-3">
                Our Vision
              </h3>
              <p className="text-gray-700">
                To become a premier group of professionals dedicated to
                promoting sustainable energy solutions for families,
                communities, and commercial/industrial entities.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-indigo-600 mb-3">
                Our Values
              </h3>
              <ul className="text-gray-700 list-disc list-inside space-y-1">
                <li>Customer satisfaction</li>
                <li>Excellence in service delivery</li>
                <li>Continuous improvement</li>
                <li>Commitment to sustainability</li>
                <li>Transparency</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="px-6 py-20 md:px-12 lg:px-24 bg-gray-50">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 border-b-2 border-indigo-400 inline-block pb-2">
            Meet Our Team
          </h2>
          <div className="mt-10 grid gap-10 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3">
            {people.map((person) => (
              <div
                key={person.name}
                className="bg-white shadow-md rounded-lg p-6 flex flex-col items-center hover:shadow-lg transition duration-300"
              >
                <img
                  src={person.imageUrl}
                  alt={person.name}
                  className="w-28 h-28 rounded-full object-cover border-2 border-indigo-300 shadow-sm mb-4"
                />
                <h3 className="text-lg font-semibold text-gray-800">
                  {person.name}
                </h3>
                <p className="text-sm text-indigo-600 font-medium">
                  {person.role}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
